<script setup>
defineProps({
    error: {
        type: Object,
        required: true,
    },
})
</script>

<template>
    <BaseSection padded>
        <div class="message">
            <BaseIcon
                class="icon"
                name="flag"
            />
            <h4
                v-if="error.title"
                class="message-title"
                v-text="error.title"
            />
            <p
                v-if="error.paragraph"
                class="message-paragraph"
                v-text="error.paragraph"
            />
        </div>
    </BaseSection>
</template>

<style lang="scss" scoped>
@import '@design';

.icon {
    @include square(5rem);
    @include iconStroke(5rem);

    color: $c-white;
}

.message {
    max-width: 40rem;
    margin: 0 auto $s-xl;
    text-align: center;

    &-paragraph {
        max-width: 25rem;
        margin-top: -1rem;
        margin-right: auto;
        margin-bottom: $s-xxl;
        margin-left: auto;
        font-size: 16px;
        color: $c-text-faded;
    }

    &-title + &-paragraph {
        @extend %contentSubtitleL;

        margin-top: 0;
        color: $c-text-faded;
    }

    &-title {
        margin-top: 0;
        margin-bottom: $s-l;
    }
}
</style>
